// VehiclesDropdown cu debug extins
import { Plus } from 'lucide-react';
import { useDropdowns } from './UseDropdowns';
import type { VehiclesDropdownProps } from '@/types/vehicles';

export const VehiclesDropdown: React.FC<VehiclesDropdownProps> = ({
  value,
  onChange,
  onAddNew,
  placeholder = "Selectează vehiculul",
  required = false,
  className = "",
  showAddButton = true
}) => {
  const { data, loading, error, refetch } = useDropdowns();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value ? parseInt(e.target.value) : null;
    const selectedVehicle = selectedId ? data.vehicles.find(v => v.id === selectedId) : undefined;
    onChange(selectedId, selectedVehicle);
  };

  // Debug extins
  console.log('=== VEHICLES DROPDOWN DEBUG ===');
  console.log('Loading:', loading);
  console.log('Error:', error);
  console.log('Data structure:', {
    hasData: !!data,
    hasVehicles: !!data?.vehicles,
    vehiclesType: typeof data?.vehicles,
    isVehiclesArray: Array.isArray(data?.vehicles),
    vehiclesLength: data?.vehicles?.length
  });
  console.log('All vehicles:', data?.vehicles);
  
  // Verifică dacă există vehiculul CJ-80-VGL
  if (data?.vehicles) {
    const cj80 = data.vehicles.find(v => 
      v.numar_inmatriculare?.includes('80') || 
      v.denumire?.includes('80') ||
      v.marca?.includes('80') ||
      v.model?.includes('80')
    );
    console.log('CJ-80-VGL found:', cj80);
  }
  console.log('===============================');

  if (loading) {
    return (
      <div className={`relative ${className}`}>
        <select disabled className="w-full px-4 py-3 border rounded-lg bg-gray-100">
          <option>Se încarcă vehiculele...</option>
        </select>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`relative ${className}`}>
        <select disabled className="w-full px-4 py-3 border rounded-lg bg-red-50 border-red-200">
          <option>Eroare: {error}</option>
        </select>
        <button
          type="button"
          onClick={refetch}
          className="mt-1 text-sm text-red-600 underline"
        >
          Reîncearcă
        </button>
      </div>
    );
  }

  // Verifică dacă data.vehicles există și este array
  if (!data || !data.vehicles || !Array.isArray(data.vehicles)) {
    return (
      <div className={`relative ${className}`}>
        <select disabled className="w-full px-4 py-3 border rounded-lg bg-yellow-50 border-yellow-200">
          <option>Date invalide pentru vehicule</option>
        </select>
        <p className="text-sm text-yellow-600 mt-1">
          Debug: {JSON.stringify({ hasData: !!data, hasVehicles: !!data?.vehicles, type: typeof data?.vehicles })}
        </p>
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <div className="flex gap-2">
        <select
          value={value || ""}
          onChange={handleChange}
          required={required}
          className="flex-1 px-4 py-3 border rounded-lg bg-white focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
        >
          <option value="">{placeholder}</option>
          {data.vehicles.map((vehicle, index) => {
            // Debug pentru fiecare vehicul
            console.log(`Vehicle ${index}:`, vehicle);
            
            return (
              <option key={vehicle.id || index} value={vehicle.id}>
                {/* Afișăm mai întâi marca și modelul dacă există, altfel denumirea */}
                {vehicle.marca && vehicle.model
                  ? `${vehicle.marca} ${vehicle.model}`
                  : vehicle.denumire || vehicle.name || `Vehicul ${vehicle.id}`
                }
                {/* Adăugăm numărul de înmatriculare dacă există */}
                {(vehicle.numar_inmatriculare || vehicle.plate_number) && 
                  ` (${vehicle.numar_inmatriculare || vehicle.plate_number})`
                }
              </option>
            );
          })}
        </select>
        {showAddButton && onAddNew && (
          <button
            type="button"
            onClick={onAddNew}
            className="px-3 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
            title="Adaugă vehicul nou"
          >
            <Plus className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="text-xs text-gray-500 mt-1">
        Debug: {data.vehicles.length} vehicule găsite
        {data.vehicles.length === 0 && " - Nu există vehicule în sistem"}
      </div>
    </div>
  );
};

export default VehiclesDropdown;